import {endpoints} from './endpoints'
import request from '../../request'

export function addReactionToItem(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addReactionToItem,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function markInteractionAsViewed(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.markInteractionAsViewed,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

	export function getUserInteractions(data) {
		return new Promise((resolve, reject) => {
			request({
				url: endpoints.getUserInteractions,
				method: 'get',
				params: data
			})
				.then(function (response) {
					resolve(response)
				})
				.catch(function (error) {
					reject(error)
				})
		})
	}